var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWindIcon = function SvgWindIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "17px",
    viewBox: "0 0 19 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "wind-icon")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wind-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.000000)",
    stroke: "#292929",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.09494702e-13,6 C7.22925681,6 11.550992,6 12.9652056,6 C14.6220598,6 15.9652056,4.65685425 15.9652056,3 C15.9652056,1.34314575 14.6220598,0 12.9652056,0 C11.3083513,0 9.96520555,1.34314575 9.96520555,3",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98260278,12.5173972 C5.36331465,12.5173972 6.48260278,11.3981091 6.48260278,10.0173972 C6.48260278,8.63668535 5.36331465,7.51739722 3.98260278,7.51739722 C2.6018909,7.51739722 1.48260278,8.63668535 1.48260278,10.0173972 C1.48260278,10.9378718 1.48260278,12.759607 1.48260278,15.4826028",
    id: "Oval",
    transform: "translate(3.982603, 11.500000) rotate(-270.000000) translate(-3.982603, -11.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9894721,14.0242666 C15.6463264,14.0242666 16.9894721,12.6811208 16.9894721,11.0242666 C16.9894721,9.36741234 15.6463264,8.02426659 13.9894721,8.02426659 C12.3326179,8.02426659 10.9894721,9.36741234 10.9894721,11.0242666 C10.9894721,12.1288361 10.9894721,13.779325 10.9894721,15.9757334",
    id: "Oval",
    transform: "translate(13.989472, 12.000000) rotate(-270.000000) translate(-13.989472, -12.000000) "
  })))));
};

export { SvgWindIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/WindIcon.ece08dda.svg";